import { BookOpen, Calendar, MessageCircle } from "lucide-react";
import * as React from "react";

import { DropdownMenuGroup, DropdownMenuItem } from "@/components/ui/dropdown";

const HELP_LINKS = [
  {
    name: "Documentation",
    href: "https://docs.promptlayer.com",
    icon: BookOpen,
  },
  {
    name: "Discord Community",
    href: "https://discord.gg/DBAhQbW39S",
    icon: MessageCircle,
  },
  {
    name: "Schedule a Call",
    href: "https://calendly.com/d/crwt-mj8-nnc/promptlayer-demo-with-david-and-jon",
    icon: Calendar,
  },
];

export const HelpLinks: React.FC = () => (
  <DropdownMenuGroup>
    {HELP_LINKS.map(link => (
      <DropdownMenuItem
        key={link.name}
        onClick={() => window.open(link.href, "_blank", "noopener,noreferrer")}
        className="mx-1 gap-2 rounded-md px-2 py-1.5 text-gray-600"
      >
        <link.icon className="size-3.5" />
        <span className="text-sm">{link.name}</span>
      </DropdownMenuItem>
    ))}
  </DropdownMenuGroup>
);
